<div class="col-12">
  <h3>{{ 'SAVED_REQUEST.FORM_TITLE' | translate }}</h3>
</div>
<div class="col-12">


  <p-dropdown id="savedSearch" [filter]="true"
              [options]="listOfSavedRequest"
              [(ngModel)]="activeRequest"
              (onChange)="emitActiveRequest()">
  </p-dropdown>

  <div class="inline" *ngIf="requestCanBeDeleted()">
    <button pButton type="button" [icon]="'fa fa-trash-o'" class="p-button-danger"
            (click)="deleteSavedRequest()">
    </button>
    <button pButton type="button" [icon]="'fa fa-calendar-check-o'" class="p-button-success"
            (click)="showSchedulingModal()">
    </button>
  </div>

</div>

<!--Schedule modal-->
<app-scheduling [(displayComponent)]="displayScheduling" [activeRequest]="activeRequest"></app-scheduling>
